import { render, staticRenderFns } from "./textStatus.vue?vue&type=template&id=25941f72&scoped=true"
import script from "./textStatus.vue?vue&type=script&lang=js"
export * from "./textStatus.vue?vue&type=script&lang=js"
import style0 from "./textStatus.vue?vue&type=style&index=0&id=25941f72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25941f72",
  null
  
)

export default component.exports